import {
  SavedStageListItem,
  StageNodeBody,
} from "store/apis/incorporationFormBuilder";

export const buildStageCreatePayloadFromSaved = (
  savedStage: SavedStageListItem,
  parentId: string
): StageNodeBody => {
  const { source_type, source_title, uuid, display_name, ...stage } =
    savedStage;

  return { ...stage, parent_id: parentId };
};
